module.exports = __webpack_public_path__ + "table-sort.b41f193a9011d4fc4e5884c2a17aad9a.png";